/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { GET_LESSONS } from "./actionTypes"
import { apiError, getLessonsSuccess } from "./actions"

//Include Both Helper File with needed methods
import { getLessons } from "../../../helpers/backend_helper"

function* get(action) {
  try {
    const response = yield call(getLessons, action.payload.courseId)
    yield put(getLessonsSuccess(response))
  } catch (error) {
    yield put(apiError(error))
  }
}

function* lessonsListSaga() {
  yield takeEvery(GET_LESSONS, get)
}

export default lessonsListSaga
